import { getErrorDetail } from "components/utility/utils";
import { fetchOrchidAPI } from "utils/api";

export default async function putGCalTwoWaySyncSettings({
  nameFormat,
  enabled,
}: {
  nameFormat: string;
  enabled: boolean;
}) {
  const res = await fetchOrchidAPI(
    "/api/scheduler_calendar_integrations/gcal_two_way_sync",
    {
      method: "PUT",
      body: JSON.stringify({
        name_format: nameFormat,
        enabled: enabled,
      }),
    },
  );
  if (!res.ok) {
    throw new Error(`failed to modify: ${getErrorDetail(await res.text())}`);
  }
  return;
}
